import React, { useEffect } from 'react';
import { User } from '../../types/auth';
import authService from '../../services/authService';

interface AuthCallbackProps {
  onLogin: (user: User) => void;
}

const AuthCallback: React.FC<AuthCallbackProps> = ({ onLogin }) => {
  useEffect(() => {
    const processCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');
      const error = urlParams.get('error');

      if (error) {
        console.error('Erro na autenticação:', error);
        window.location.href = '/login?error=' + error;
        return;
      }

      if (token) {
        try {
          authService.setToken(token);
          const userData = await authService.getProfile();
          onLogin(userData);
        } catch (error) {
          console.error('Erro ao processar token:', error);
          window.location.href = '/login?error=token_invalid';
        }
      } else {
        window.location.href = '/login?error=no_token';
      }
    };

    processCallback();
  }, []); // Array vazio - executa apenas uma vez

  return (
    <div className="d-flex justify-content-center align-items-center" style={{height: '100vh'}}>
      <div className="text-center">
        <output className="spinner-border text-success mb-3">
          <span className="visually-hidden">Processando...</span>
        </output>
        <p>Processando autenticação...</p>
      </div>
    </div>
  );
};

export default AuthCallback;